<template>
  <div class="funcionalidade-header"
       :style="estiloLogin">
    <div
      class="funcionalidade-header-float"
      :style="estiloLogin"
    >
      <div class="funcionalidade-header-content">
        <div class="ellipsis" style="flex: 1;">
          <h1 class="ellipsis" :style="estiloTituloNavegacao">{{ tituloNavegacao }}</h1>
        </div>
        <el-button
          class="button-voltar"
          v-if="voltar"
          :style="estiloVoltarNavegacao"
          type="text"
          @click="clickVoltar"
        >
          <i class="el-icon-back" /> Voltar
        </el-button>
        <!-- TODO: 28/09/2022 martinazzi Desabilitando até segunda ordem -->
        <el-button
          v-if="info && false"
          :style="estiloIconeNavegacao"
          type="text"
        >
          <i class="el-icon-warning-outline" />
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'FuncionalidadeHeader',
  props: {
    voltar: {
      type: Boolean,
      default: true
    },
    info: {
      type: Boolean,
      default: true
    },
    customVoltar: {
      type: Boolean,
      default: false
    },
    titulo: {
      type: String,
      default: ''
    },
    menuFuncionalidades: {
      type: Array,
      default: () => []
    },
    login: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    funcData () {
      return this.funcionalidade || {}
    },
    funcParametros () {
      return this.funcData.parametros || {}
    },
    tituloNavegacao () {
      return this.titulo
    },
    estiloTituloNavegacao () {
      return {
        color: this.funcParametros.corTituloNavegacao
      }
    },
    estiloIconeNavegacao () {
      return {
        color: this.funcParametros.corIconeNavegacao
      }
    },
    estiloVoltarNavegacao () {
      return {
        color: this.funcParametros.corVoltarNavegacao
      }
    },
    estiloLogin () {
      if (this.login) {
        return {
          'padding': '20px 0',
          'box-shadow': 'none',
          'position': 'initial'
        }
      }
      return {}
    }
  },
  methods: {
    clickVoltar () {
      if (this.customVoltar) {
        return this.$emit('click')
      }
      window.history.go(-1)
    }
  }
}
</script>
<style scoped>
.funcionalidade-header {
  min-height: 80px;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 1750px;
}

.funcionalidade-header-float {
  box-shadow: 0 1px 0 #eeeeee;
  background: #FFFFFF 0 0 no-repeat padding-box;
  padding: 20px;
  min-height: 40px;
  /*position: fixed;*/
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}

.funcionalidade-header-content {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

@media print {
  .button-voltar {
    display: none;
  }
}

.button-voltar {
  font-size: 15px;
  text-transform: none;
  font-family: Open Sans;
}

.button-voltar i {
  font-weight: 600;
}
</style>
